import(/* webpackMode: "eager" */ "/home/runner/_work/canales_a_clientes-1133-login/canales_a_clientes-1133-login/packages/front-account/app/recuperar-clave/recovery.module.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/canales_a_clientes-1133-login/canales_a_clientes-1133-login/packages/front-account/journeys/recovery/recovery-form/recovery-form.component.tsx");
